import {
    UNLOAD_SNOWFLAKE_TABLE,
    LOAD_SNOWFLAKE_TABLE,
    RUN_FULL_MATERIALIZATION,
    RUN_INCREMENTAL_MATERIALIZATION,
    CALL_SNOWFLAKE_STORED_PROCEDURE
} from 'app/lib/types/server';

export enum JobOperationType {
    DBT = 'europa.dbt.CollectDbtModels',
    LOAD = 'europa.job.LoadSnowflakeTable',
    SNOWFLAKE_HISTORY_INDEXING = 'europa.dataquality.CollectSnowflakeEvents',
    STORED_PROCEDURE = 'europa.job.implementation.CallSnowflakeStoredProcedure',
    TABLE_METRICS = 'europa.job.implementation.CollectRoiTableMetrics',
    UNLOAD = 'europa.job.UnloadSnowflakeTable',
    WAREHOUSE_USAGE = 'europa.job.implementation.CollectWarehouseUsage',
    MODEL_JOB = 'europa.project.model.RunFullMaterialization',
    INCREMENTAL_MODEL_JOB = 'europa.project.model.RunIncrementalMaterialization'
}

export enum JobCandidatesType {
    MODEL_JOB = 'europa.job.management.ModelJob',
    STORED_PROC_JOB = 'europa.job.management.StoredProcJob',
    DEPLOYED_NODE = 'europa.job.management.DeployedNodeJob',
    DEFAULT_JOB = 'europa.job.management.DefaultJob'
}

export enum MODEL_JOB_STATUS_ICON {
    BROKEN = 'error-solid',
    GOOD = 'check-circle-solid',
    POTENTIALLY_BROKEN = 'status-warning-solid',
    STALE = 'cache-refresh-next'
}

export const JOB_TYPE_MAP = {
    [CALL_SNOWFLAKE_STORED_PROCEDURE]: {
        icon: 'dynamic-table',
        title: 'jobs:definitions.jobType.storedProcedure'
    },
    [LOAD_SNOWFLAKE_TABLE]: {
        icon: 'snowflake',
        title: 'jobs:definitions.jobType.importFromCloud'
    },
    [UNLOAD_SNOWFLAKE_TABLE]: {
        icon: 'snowflake',
        title: 'jobs:definitions.jobType.exportToCloud'
    },
    [RUN_FULL_MATERIALIZATION]: {
        icon: 'dynamic-table',
        title: 'jobs:definitions.jobType.modelJob'
    },
    [RUN_INCREMENTAL_MATERIALIZATION]: {
        icon: 'dynamic-table',
        title: 'jobs:definitions.jobType.modelJob'
    },

    DEFAULT: {
        icon: 'system',
        title: 'jobs:definitions.jobType.system'
    }
};
